import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'
import DesmosActsContainer from './containers/DesmosActs'

export function DesmosActsPage() {
    const { t } = useTranslation()

    return (
        <PageContainer>
            <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
                {t('page.admin.desmosActs.title', { defaultValue: 'Desmos Acts Management' })}
            </Typography>
            <DesmosActsContainer />
        </PageContainer>
    )
}

export default DesmosActsPage
